import React, { useEffect, useState, useRef, useCallback } from 'react';

export default function ShareButton(props) {
  const [popup, setPopup] = useState(false);

  const ref = useRef(null);

  const handleClick = useCallback((value, event) => {
    setPopup(false);
    props.onClick(value, event);
  }, []);

  const handleDocumentClick = useCallback((event) => {
    if (!ref.current?.contains(event.target)) {
      if (popup) {
        setPopup(false);
      }
    }
  }, []);

  const handleListBoxKeyDown = useCallback((event) => {
    if (event.keyCode === 27) {
      if (open) {
        setOpen(false);
      }
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, false);

    return function cleanup() {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('touchend', handleDocumentClick, false);
    };
  });

  return (
    <div className={`live_btn_share ${popup ? 'current' : ''}`}>
      <button
        className="live_link_cont"
        title="공유하기 레이어 열기"
        aria-label={`공유하기 레이어 팝업`}
        aria-expanded={`${popup ? 'true' : 'false'}`}
        onClick={() => setPopup(!popup)}
      >
        <span className="live_btn_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30.002"
            height="26"
            viewBox="0 0 30.002 26"
          >
            <g transform="translate(-637.546 -498.729)">
              <path d="M662.655,512.874h0a1.021,1.021,0,0,0-1.024,1.018h0v8.8H639.6V507.214h6.157a1.02,1.02,0,1,0,.064-2.039h-7.247a1.023,1.023,0,0,0-1.025,1.019h0v17.514a1.022,1.022,0,0,0,1.024,1.02h24.084a1.02,1.02,0,0,0,1.024-1.018v-9.818A1.021,1.021,0,0,0,662.655,512.874Z"></path>
              <path d="M667.405,503.958v0l-4.879-5.079a.467.467,0,0,0-.566-.09.52.52,0,0,0-.253.54l.435,2.634c-2.613.2-13.365,1.8-15.522,14.148a.512.512,0,0,0,.341.581.45.45,0,0,0,.136.021.484.484,0,0,0,.449-.316,15.821,15.821,0,0,1,15.231-10.351l-1.051,3.186a.525.525,0,0,0,.2.6.467.467,0,0,0,.6-.068l4.879-5.079A.53.53,0,0,0,667.405,503.958Z"></path>
            </g>
          </svg>
          <i className="hide">공유하기</i>
        </span>
      </button>
      <div className="layer_share_list">
        <button
          role="button"
          className="layer_share_link"
          tabIndex={popup ? '0' : '-1'}
          title="페이스북에 공유 새창 열림"
          onClick={(event) => handleClick('facebook', event)}
        >
          <span className="icon_share_facebook">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
            >
              <g transform="translate(-292.917 -400.958)">
                <rect
                  width="36"
                  height="36"
                  transform="translate(292.917 400.958)"
                ></rect>
                <path d="M314.09,412.995h1.327v-2.589a16.139,16.139,0,0,0-2.355-.206c-2.4,0-3.974,1.457-3.974,4.093v2.318h-2.671v3.041h2.671v8.064h3.288v-8.064h2.451l.466-3.041h-2.917v-1.973A1.52,1.52,0,0,1,314.09,412.995Z"></path>
              </g>
            </svg>
          </span>
        </button>
        <button
          role="button"
          className="layer_share_link"
          title="트위터에 공유 새창 열림"
          tabIndex={popup ? '0' : '-1'}
          onClick={(event) => handleClick('twitter', event)}
        >
          <span className="icon_share_twitter">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
            >
              <g transform="translate(-338.278 -401)">
                <rect
                  width="36"
                  height="36"
                  transform="translate(338.278 401)"
                ></rect>
                <path d="M353.647,427.327a10.436,10.436,0,0,0,10.508-10.507c0-.16,0-.32-.011-.478a7.529,7.529,0,0,0,1.843-1.912,7.362,7.362,0,0,1-2.121.581,3.7,3.7,0,0,0,1.624-2.043,7.391,7.391,0,0,1-2.345.9,3.7,3.7,0,0,0-6.294,3.368,10.484,10.484,0,0,1-7.612-3.859,3.7,3.7,0,0,0,1.144,4.931,3.683,3.683,0,0,1-1.673-.462c0,.015,0,.03,0,.047a3.694,3.694,0,0,0,2.963,3.62,3.681,3.681,0,0,1-.974.13,3.613,3.613,0,0,1-.694-.067,3.7,3.7,0,0,0,3.45,2.565,7.407,7.407,0,0,1-4.587,1.581,7.522,7.522,0,0,1-.88-.051,10.448,10.448,0,0,0,5.66,1.659"></path>
              </g>
            </svg>
          </span>
        </button>
        <button
          role="button"
          className="layer_share_link"
          title="카카오스토리에 공유 새창 열림"
          tabIndex={popup ? '0' : '-1'}
          onClick={(event) => handleClick('kakaostory', event)}
        >
          <span className="icon_share_kakao">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
            >
              <g transform="translate(-383.639 -401)">
                <rect
                  width="36"
                  height="36"
                  transform="translate(383.639 401)"
                ></rect>
                <path d="M405.148,411.1h-7.24a.878.878,0,0,0-.88.875v7.18a.878.878,0,0,0,.88.875h3.338a5.406,5.406,0,0,1-.9,2.608,10.5,10.5,0,0,1-1.831,1.964.48.48,0,0,0-.17.352.5.5,0,0,0,.124.295l2.328,2.61a.568.568,0,0,0,.206.141.369.369,0,0,0,.308-.035,11.7,11.7,0,0,0,4.713-9.089c0-.012,0-6.9,0-6.9a.878.878,0,0,0-.88-.875"></path>
              </g>
            </svg>
          </span>
        </button>
        <button
          role="button"
          className="layer_share_link"
          id="sbsmain-live-button-share-clipboad"
          title="url로 공유하기"
          tabIndex={popup ? '0' : '-1'}
          onClick={(event) => handleClick('clipboard', event)}
        >
          <span className="icon_share_url">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
            >
              <g transform="translate(-429 -401)">
                <rect
                  width="36"
                  height="36"
                  transform="translate(429 401)"
                ></rect>
                <g>
                  <path
                    d="M635.852,564.211q-.027,1.9-1.835,1.9a1.876,1.876,0,0,1-1.353-.468,1.988,1.988,0,0,1-.489-1.49v-6.862h-2.143v6.927a3.447,3.447,0,0,0,1.093,2.648,4.151,4.151,0,0,0,2.892.965,4.109,4.109,0,0,0,2.917-.993,3.5,3.5,0,0,0,1.068-2.7v-6.849l-2.15,0Z"
                    transform="translate(-196.03 -143.277)"
                  ></path>
                  <path
                    d="M647,562.2a3.181,3.181,0,0,0,.461-1.774,2.833,2.833,0,0,0-1-2.32,4.356,4.356,0,0,0-2.842-.822h-3.863v10.4H641.9v-3.8h1.707l1.945,3.8h2.3v-.1l-2.25-4.248A3.139,3.139,0,0,0,647,562.2Zm-2.124-.468a1.771,1.771,0,0,1-1.25.411H641.9v-3.12h1.721a1.737,1.737,0,0,1,1.281.42,1.57,1.57,0,0,1,.418,1.157A1.468,1.468,0,0,1,644.879,561.734Z"
                    transform="translate(-196.03 -143.277)"
                  ></path>
                  <path
                    d="M651.234,565.966v-8.68h-2.142v10.4h6.691v-1.72Z"
                    transform="translate(-196.03 -143.277)"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
        </button>
        <button
          className="layer_share_close"
          title="공유 레이어 닫기"
          tabIndex={popup ? '0' : '-1'}
          aria-label="팝업 닫기"
          onClick={() => setPopup(!popup)}
        >
          <span className="icon_share_close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
            >
              <g transform="translate(-164.018 -178.02)">
                <g transform="translate(164.018 178.02)">
                  <path
                    d="M12.17,1.271.521,1.434A.572.572,0,0,1,0,.806H0A.612.612,0,0,1,.538.163L12.188,0a.572.572,0,0,1,.521.628h0A.612.612,0,0,1,12.17,1.271Z"
                    transform="translate(1.014 0) rotate(45)"
                  ></path>
                  <path
                    d="M12.17.163.521,0A.572.572,0,0,0,0,.628H0a.612.612,0,0,0,.538.643l11.649.163a.572.572,0,0,0,.521-.628h0A.612.612,0,0,0,12.17.163Z"
                    transform="translate(10 1.014) rotate(135)"
                  ></path>
                </g>
              </g>
            </svg>
            <i className="hide">닫기</i>
          </span>
        </button>
      </div>
    </div>
  );
}
